function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-onboard",
  x1: 220.02,
  y1: 324.65,
  x2: 55.9,
  y2: 198.75,
  gradientTransform: "matrix(1, 0, 0, -1, 0, 362)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#6d6d82"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#222243"
}));
var _ref3 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: -2071.97,
  cy: 1906.93,
  r: 0.98,
  gradientTransform: "matrix(0, -6.97, -6.48, 0, 12384.32, -14398.94)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fd5"
}), React.createElement("stop", {
  offset: 0.1,
  stopColor: "#fd5"
}), React.createElement("stop", {
  offset: 0.5,
  stopColor: "#ff543e"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#c837ab"
}));
var _ref4 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-2",
  cx: -1158.44,
  cy: 2289.92,
  r: 0.98,
  gradientTransform: "matrix(0.61, 3.05, 12.59, -2.52, -28110.56, 9344.94)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#3771c8"
}), React.createElement("stop", {
  offset: 0.13,
  stopColor: "#3771c8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#60f",
  stopOpacity: 0
}));
var _ref5 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-3",
  cx: -1590.24,
  cy: 1954.07,
  r: 0.98,
  gradientTransform: "matrix(7.7, 0, 0, -7.7, 12265.87, 15161.7)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#09f"
}), React.createElement("stop", {
  offset: 0.6,
  stopColor: "#a033ff"
}), React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ff5280"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ff7061"
}));
var _ref6 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-4",
  cx: -2071.86,
  cy: 1907.62,
  r: 0.98,
  gradientTransform: "matrix(0, -6.97, -6.48, 0, 12606.32, -14359.94)",
  xlinkHref: "#radial-gradient"
});
var _ref7 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-5",
  cx: -1158.97,
  cy: 2289.59,
  r: 0.98,
  gradientTransform: "matrix(0.61, 3.05, 12.59, -2.52, -27888.56, 9383.94)",
  xlinkHref: "#radial-gradient-2"
});
var _ref8 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-6",
  cx: -1590.83,
  cy: 1954.18,
  r: 0.98,
  gradientTransform: "matrix(7.7, 0, 0, -7.7, 12487.87, 15200.7)",
  xlinkHref: "#radial-gradient-3"
});
var SvgFacebookOnboard1 = function SvgFacebookOnboard1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 264 209",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("defs", null, _ref2, React.createElement("clipPath", {
    id: "clip-path"
  }, React.createElement("rect", {
    x: 19.84,
    y: 32.05,
    width: 7,
    height: 7,
    style: {
      fill: "none"
    }
  })), _ref3, _ref4, React.createElement("clipPath", {
    id: "clip-path-2"
  }, React.createElement("rect", {
    x: 19.84,
    y: 108.47,
    width: 6.86,
    height: 6.86,
    style: {
      fill: "none"
    }
  })), _ref5, React.createElement("clipPath", {
    id: "clip-path-3"
  }, React.createElement("rect", {
    x: 237.35,
    y: 70.26,
    width: 7,
    height: 7,
    style: {
      fill: "none"
    }
  })), _ref6, _ref7, React.createElement("clipPath", {
    id: "clip-path-4"
  }, React.createElement("rect", {
    x: 237.35,
    y: 146.68,
    width: 6.86,
    height: 6.86,
    style: {
      fill: "none"
    }
  })), _ref8), React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "backing"
  }, React.createElement("path", {
    d: "M39.81,39.89A29.39,29.39,0,0,1,69.2,10.49H195.14a29.39,29.39,0,0,1,29.39,29.4V169.61A29.39,29.39,0,0,1,195.14,199H69.2a29.39,29.39,0,0,1-29.39-29.39Z",
    style: {
      fill: "url(#linear-gradient-onboard)"
    }
  })), React.createElement("g", {
    id: "front"
  }, React.createElement("rect", {
    x: 23.2,
    y: 35.84,
    width: 118,
    height: 26.22,
    rx: 9.8,
    style: {
      fill: "#fff",
      fillOpacity: 0.23999999463558197
    }
  }), React.createElement("circle", {
    cx: 23.2,
    cy: 35.84,
    r: 7.28,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    cx: 23.2,
    cy: 35.84,
    r: 11.2,
    style: {
      fill: "none",
      stroke: "#000",
      strokeOpacity: 0.10000000149011612,
      strokeWidth: 8
    }
  }), React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, React.createElement("path", {
    d: "M23.34,32.1H21.4a1.78,1.78,0,0,0-.68.17,1.47,1.47,0,0,0-.4.29,1.51,1.51,0,0,0-.4.84,6.64,6.64,0,0,0,0,1v1.11c0,1.44,0,1.86,0,1.94a1.78,1.78,0,0,0,.16.67,1.48,1.48,0,0,0,.94.77,2.38,2.38,0,0,0,.51.06h3.64a2.85,2.85,0,0,0,.52-.07,1.43,1.43,0,0,0,.94-.77,1.77,1.77,0,0,0,.17-.66v-3.9a1.72,1.72,0,0,0-.17-.65,1.24,1.24,0,0,0-.3-.41,1.45,1.45,0,0,0-.83-.4,6.87,6.87,0,0,0-1,0Z",
    style: {
      fill: "url(#radial-gradient)"
    }
  }), React.createElement("path", {
    d: "M23.34,32.1H21.4a1.78,1.78,0,0,0-.68.17,1.47,1.47,0,0,0-.4.29,1.51,1.51,0,0,0-.4.84,6.64,6.64,0,0,0,0,1v1.11c0,1.44,0,1.86,0,1.94a1.78,1.78,0,0,0,.16.67,1.48,1.48,0,0,0,.94.77,2.38,2.38,0,0,0,.51.06h3.64a2.85,2.85,0,0,0,.52-.07,1.43,1.43,0,0,0,.94-.77,1.77,1.77,0,0,0,.17-.66v-3.9a1.72,1.72,0,0,0-.17-.65,1.24,1.24,0,0,0-.3-.41,1.45,1.45,0,0,0-.83-.4,6.87,6.87,0,0,0-1,0Z",
    style: {
      fill: "url(#radial-gradient-2)"
    }
  }), React.createElement("path", {
    d: "M23.34,33c-.69,0-.78,0-1.05,0a1.66,1.66,0,0,0-.62.12,1.27,1.27,0,0,0-.74.74,1.66,1.66,0,0,0-.12.62c0,.27,0,.36,0,1s0,.77,0,1.05a1.6,1.6,0,0,0,.12.61,1.16,1.16,0,0,0,.29.45,1.19,1.19,0,0,0,.45.3,2.19,2.19,0,0,0,.62.12h2.09A2.12,2.12,0,0,0,25,38a1.19,1.19,0,0,0,.45-.3,1.32,1.32,0,0,0,.3-.45,1.85,1.85,0,0,0,.11-.61c0-.28,0-.36,0-1.05s0-.78,0-1a1.92,1.92,0,0,0-.11-.62,1.32,1.32,0,0,0-.3-.45,1.16,1.16,0,0,0-.45-.29,1.62,1.62,0,0,0-.62-.12c-.27,0-.35,0-1,0Zm-.23.46h.23c.68,0,.76,0,1,0a1.63,1.63,0,0,1,.48.08.81.81,0,0,1,.29.19.85.85,0,0,1,.19.3,1.46,1.46,0,0,1,.09.47c0,.27,0,.35,0,1s0,.76,0,1a1.54,1.54,0,0,1-.09.48.91.91,0,0,1-.19.29.81.81,0,0,1-.29.19,1.54,1.54,0,0,1-.48.09H22.31a1.81,1.81,0,0,1-.47-.09.85.85,0,0,1-.3-.19.91.91,0,0,1-.19-.29,1.63,1.63,0,0,1-.08-.48c0-.26,0-.35,0-1s0-.76,0-1a1.48,1.48,0,0,1,.08-.47.81.81,0,0,1,.49-.49,1.81,1.81,0,0,1,.47-.09Zm1.58.42a.31.31,0,0,0-.3.31.31.31,0,0,0,.61,0,.31.31,0,0,0-.31-.31Zm-1.35.36a1.31,1.31,0,1,0,1.3,1.31,1.31,1.31,0,0,0-1.3-1.31Zm0,.46a.85.85,0,0,1,.84.85.85.85,0,0,1-1.69,0,.85.85,0,0,1,.85-.85Z",
    style: {
      fill: "#fff"
    }
  })), React.createElement("rect", {
    x: 33.98,
    y: 43.42,
    width: 98.48,
    height: 4.08,
    rx: 1.96,
    style: {
      fill: "#fff",
      fillOpacity: 0.47999998927116394
    }
  }), React.createElement("rect", {
    x: 33.98,
    y: 50.41,
    width: 49.53,
    height: 4.08,
    rx: 1.96,
    style: {
      fill: "#fff",
      fillOpacity: 0.47999998927116394
    }
  }), React.createElement("rect", {
    x: 23.2,
    y: 112.18,
    width: 118,
    height: 26.22,
    rx: 9.8,
    style: {
      fill: "#fff",
      fillOpacity: 0.23999999463558197
    }
  }), React.createElement("circle", {
    cx: 23.2,
    cy: 112.18,
    r: 7.28,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    cx: 23.2,
    cy: 112.18,
    r: 11.2,
    style: {
      fill: "none",
      stroke: "#000",
      strokeOpacity: 0.10000000149011612,
      strokeWidth: 8
    }
  }), React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, React.createElement("path", {
    d: "M23.27,108.47a3.31,3.31,0,0,0-3.43,3.33,3.28,3.28,0,0,0,1.07,2.46.3.3,0,0,1,.1.19l0,.61a.28.28,0,0,0,0,.13.43.43,0,0,0,.09.1.28.28,0,0,0,.13,0,.3.3,0,0,0,.13,0l.68-.3a.28.28,0,0,1,.18,0,3.66,3.66,0,0,0,1,.14,3.33,3.33,0,1,0,0-6.66Z",
    style: {
      fill: "url(#radial-gradient-3)"
    }
  }), React.createElement("path", {
    d: "M21.21,112.77l1-1.6a.4.4,0,0,1,.14-.15.5.5,0,0,1,.41-.07A.37.37,0,0,1,23,111l.8.6a.22.22,0,0,0,.25,0l1.08-.83a.17.17,0,0,1,.24.22l-1,1.6a.54.54,0,0,1-.15.15.46.46,0,0,1-.19.08.74.74,0,0,1-.21,0,.56.56,0,0,1-.19-.09l-.81-.6a.18.18,0,0,0-.12,0,.17.17,0,0,0-.12,0l-1.09.82a.16.16,0,0,1-.23-.22Z",
    style: {
      fill: "#fff"
    }
  })), React.createElement("rect", {
    x: 33.98,
    y: 119.75,
    width: 98.48,
    height: 4.08,
    rx: 1.96,
    style: {
      fill: "#fff",
      fillOpacity: 0.47999998927116394
    }
  }), React.createElement("rect", {
    x: 33.98,
    y: 126.74,
    width: 49.53,
    height: 4.08,
    rx: 1.96,
    style: {
      fill: "#fff",
      fillOpacity: 0.47999998927116394
    }
  }), React.createElement("rect", {
    x: 122.84,
    y: 74.01,
    width: 118,
    height: 26.22,
    rx: 9.8,
    style: {
      fill: "#4b86fa"
    }
  }), React.createElement("circle", {
    cx: 240.71,
    cy: 74.05,
    r: 7.28,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    cx: 240.71,
    cy: 74.05,
    r: 11.2,
    style: {
      fill: "none",
      stroke: "#000",
      strokeOpacity: 0.10000000149011612,
      strokeWidth: 8
    }
  }), React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, React.createElement("path", {
    d: "M240.85,70.31h-1.94a1.78,1.78,0,0,0-.68.17,1.64,1.64,0,0,0-.4.29,1.57,1.57,0,0,0-.4.84,6.64,6.64,0,0,0,0,1v1.12c0,1.43,0,1.85,0,1.94a1.77,1.77,0,0,0,.17.66,1.45,1.45,0,0,0,.94.77,2.23,2.23,0,0,0,.5.07h3.65a2.16,2.16,0,0,0,.51-.07,1.47,1.47,0,0,0,.95-.77,1.72,1.72,0,0,0,.16-.65v-3.9a1.56,1.56,0,0,0-.17-.66,1.69,1.69,0,0,0-.29-.41,1.51,1.51,0,0,0-.84-.4,9,9,0,0,0-1,0Z",
    style: {
      fill: "url(#radial-gradient-4)"
    }
  }), React.createElement("path", {
    d: "M240.85,70.31h-1.94a1.78,1.78,0,0,0-.68.17,1.64,1.64,0,0,0-.4.29,1.57,1.57,0,0,0-.4.84,6.64,6.64,0,0,0,0,1v1.12c0,1.43,0,1.85,0,1.94a1.77,1.77,0,0,0,.17.66,1.45,1.45,0,0,0,.94.77,2.23,2.23,0,0,0,.5.07h3.65a2.16,2.16,0,0,0,.51-.07,1.47,1.47,0,0,0,.95-.77,1.72,1.72,0,0,0,.16-.65v-3.9a1.56,1.56,0,0,0-.17-.66,1.69,1.69,0,0,0-.29-.41,1.51,1.51,0,0,0-.84-.4,9,9,0,0,0-1,0Z",
    style: {
      fill: "url(#radial-gradient-5)"
    }
  }), React.createElement("path", {
    d: "M240.85,71.21c-.69,0-.78,0-1,0a1.89,1.89,0,0,0-.62.12,1.16,1.16,0,0,0-.45.29,1.24,1.24,0,0,0-.29.45,1.66,1.66,0,0,0-.12.62c0,.27,0,.36,0,1.05s0,.78,0,1a1.6,1.6,0,0,0,.12.61,1.16,1.16,0,0,0,.29.45,1.19,1.19,0,0,0,.45.3,2.19,2.19,0,0,0,.62.12h2.1a2.11,2.11,0,0,0,.61-.12,1.38,1.38,0,0,0,.75-.75,2.11,2.11,0,0,0,.12-.61c0-.27,0-.36,0-1s0-.78,0-1.05a2.19,2.19,0,0,0-.12-.62,1.27,1.27,0,0,0-.3-.45,1.16,1.16,0,0,0-.45-.29,1.82,1.82,0,0,0-.61-.12c-.28,0-.36,0-1.05,0Zm-.23.46h.23c.68,0,.76,0,1,0a1.27,1.27,0,0,1,.47.09.7.7,0,0,1,.29.19.73.73,0,0,1,.19.29,1.22,1.22,0,0,1,.09.47c0,.27,0,.35,0,1s0,.76,0,1a1.27,1.27,0,0,1-.09.47.85.85,0,0,1-.48.48,1.52,1.52,0,0,1-.47.09h-2.06a1.46,1.46,0,0,1-.47-.09.85.85,0,0,1-.3-.19,1,1,0,0,1-.19-.29,1.61,1.61,0,0,1-.08-.47c0-.27,0-.35,0-1s0-.76,0-1a1.54,1.54,0,0,1,.08-.47.81.81,0,0,1,.49-.49,1.54,1.54,0,0,1,.47-.08c.23,0,.33,0,.8,0Zm1.59.43a.3.3,0,0,0-.31.3.31.31,0,1,0,.61,0,.3.3,0,0,0-.3-.3Zm-1.36.35a1.31,1.31,0,1,0,0,2.61,1.31,1.31,0,0,0,0-2.61Zm0,.46a.85.85,0,1,1-.85.85.85.85,0,0,1,.85-.85Z",
    style: {
      fill: "#fff"
    }
  })), React.createElement("rect", {
    x: 133.63,
    y: 81.58,
    width: 98.48,
    height: 4.08,
    rx: 1.96,
    style: {
      fill: "#fff",
      fillOpacity: 0.2199999988079071
    }
  }), React.createElement("rect", {
    x: 133.63,
    y: 88.58,
    width: 49.53,
    height: 4.08,
    rx: 1.96,
    style: {
      fill: "#fff",
      fillOpacity: 0.2199999988079071
    }
  }), React.createElement("rect", {
    x: 122.85,
    y: 150.34,
    width: 118,
    height: 26.22,
    rx: 9.8,
    style: {
      fill: "#4b86fa"
    }
  }), React.createElement("circle", {
    cx: 240.84,
    cy: 150.34,
    r: 7.28,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    cx: 240.84,
    cy: 150.34,
    r: 11.2,
    style: {
      fill: "none",
      stroke: "#000",
      strokeOpacity: 0.10000000149011612,
      strokeWidth: 8
    }
  }), React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, React.createElement("path", {
    d: "M240.78,146.68a3.31,3.31,0,0,0-3.43,3.33,3.25,3.25,0,0,0,1.08,2.46.29.29,0,0,1,.09.2l0,.61a.27.27,0,0,0,0,.12.45.45,0,0,0,.09.1.33.33,0,0,0,.13,0,.27.27,0,0,0,.13,0l.68-.3a.31.31,0,0,1,.19,0,3.53,3.53,0,0,0,1,.14,3.33,3.33,0,1,0,0-6.66Z",
    style: {
      fill: "url(#radial-gradient-6)"
    }
  }), React.createElement("path", {
    d: "M238.72,151l1-1.6a.67.67,0,0,1,.14-.15.7.7,0,0,1,.2-.08.5.5,0,0,1,.21,0,.48.48,0,0,1,.19.09l.8.6a.2.2,0,0,0,.13,0,.28.28,0,0,0,.12,0l1.08-.82a.16.16,0,0,1,.24.21l-1,1.6a.54.54,0,0,1-.15.15.41.41,0,0,1-.19.08.5.5,0,0,1-.21,0,.56.56,0,0,1-.19-.09l-.8-.6a.2.2,0,0,0-.13,0,.17.17,0,0,0-.12,0l-1.08.82a.17.17,0,0,1-.24-.22Z",
    style: {
      fill: "#fff"
    }
  })), React.createElement("rect", {
    x: 133.63,
    y: 157.92,
    width: 98.48,
    height: 4.08,
    rx: 1.96,
    style: {
      fill: "#fff",
      fillOpacity: 0.2199999988079071
    }
  }), React.createElement("rect", {
    x: 133.63,
    y: 164.91,
    width: 49.53,
    height: 4.08,
    rx: 1.96,
    style: {
      fill: "#fff",
      fillOpacity: 0.2199999988079071
    }
  }), React.createElement("rect", {
    width: 264,
    height: 209,
    style: {
      fill: "none"
    }
  }))));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebookOnboard1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FacebookOnboard1.baf4ec23.svg";
export { ForwardRef as ReactComponent };